// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"66729fce","733":"66729fce"}[chunkId] + ".chunk.css";
};